import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import CheckboxList from './CheckboxList'
import LookingForTirePrices from './LookingForTirePrices'

const ServicesBlock = ({
  className,
  hidden,
  input,
  title,
  showLookingForTirePrices,
  popularServices,
  servicesDrawer,
  ...props
}) =>
  <CheckboxWrapper
    className={ className }
    threeStepper={ popularServices || servicesDrawer }
    hidden={ hidden }>
    <legend>
      <Media.ScreenReader>{ title } Services Checklist</Media.ScreenReader>
    </legend>
    <CheckboxList
      { ...input }
      { ...props }
      inline
      servicesDrawer={ servicesDrawer }
      dataAttributes={{ 'data-at-quickappointment-service': true }} />

    { showLookingForTirePrices && <LookingForTirePrices servicesDrawer={ servicesDrawer } /> }
  </CheckboxWrapper>

ServicesBlock.propTypes = {
  className: PropTypes.string,
  hidden: PropTypes.bool,
  input: PropTypes.shape(),
  popularServices: PropTypes.bool,
  services: PropTypes.arrayOf(PropTypes.shape()),
  servicesDrawer: PropTypes.bool,
  showLookingForTirePrices: PropTypes.bool,
  title: PropTypes.string
}

export default ServicesBlock

const CheckboxWrapper = styled.fieldset`
  width: 100%;
  float: left;
  text-align: left;
  border: 1px solid ${Theme.colors.light_grey};
  background-color: ${Theme.colors.off_white};
  ${Mixin.responsive('padding', '30px', '25px 20px 20px')}
  ${props => props.threeStepper && css`
    float: none;
    background-color: unset;
    border: none;
    && {
      padding: 0;
    }
  `}
`
